module.exports = "../../app/cells/components/how_study_for_contests_cell.rb";